@import '../table/pageWithTable.module.scss';
